import { Component, TemplateRef } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyFieldProps } from '@ngx-formly/primeng/form-field';
import { FORM_IMPORTS } from '../../_shared/_imports/form.import';
import { CommonModule } from '@angular/common';

export interface TemplateFieldProps extends FormlyFieldProps {
  templateRef: TemplateRef<any>;
}

@Component({
  selector: 'template-field',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (props['templateRef']) {
      <ng-container
        [ngTemplateOutlet]="props['templateRef']"
        [ngTemplateOutletContext]="{ $implicit: formControl.value }"
      >
      </ng-container>
    }
  `,
})
export class TemplateFieldType extends FieldType {}
